import { render } from "./_token.vue?vue&type=template&id=3ea96330&scoped=true&ts=true"
import script from "./_token.vue?vue&type=script&lang=ts"
export * from "./_token.vue?vue&type=script&lang=ts"

import "./_token.vue?vue&type=style&index=0&id=3ea96330&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea96330"]])

export default __exports__